import { render, staticRenderFns } from "./GameData.vue?vue&type=template&id=7b4cd4bb&scoped=true&"
import script from "./GameData.vue?vue&type=script&lang=js&"
export * from "./GameData.vue?vue&type=script&lang=js&"
import style0 from "./GameData.vue?vue&type=style&index=0&id=7b4cd4bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4cd4bb",
  null
  
)

export default component.exports